import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { lagerSelector, lagerByIntNrSelector } from 'store/lookups/selector';

interface LagerByIntNrProps {
    label: string;
    disabled: boolean;
    value: number;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: number) => void;
}

export const LagerByIntNr: React.FC<LagerByIntNrProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const lager = useSelector(lagerSelector);
    const lagerByIntNr = useSelector(lagerByIntNrSelector);

    const options = React.useMemo(() => {
        const o = lager
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((l) => ({
                value: l.intNr.toString(),
                label: l.name,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [lager, allowEmpty]);

    return (
        <>
            <Label>{label}</Label>
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: lagerByIntNr[value]?.name || value.toString(),
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(parseInt(option?.value || '0', 10));
                }}
            />
        </>
    );
};
